import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { ITicketHead } from "../interfaces";
import Axios from "axios";
import config from "../config";
import CoreComponent from "./CoreComponent";
import TicketModal from "../components/TicketModal";

interface IState {
    models: ITicketHead[];
    isLoading: boolean;
    ids: number[];
    sort: string;
    type: string;
    isOpen: boolean;
    filter: string;
}

class Quastions extends CoreComponent<any, IState> {
    state: IState = {
        models: [],
        isLoading: true,
        ids: [],
        sort: "",
        type: "",
        isOpen: false,
        filter: "all",
    };

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    componentWillMount() {
        this.loadModels();
    }

    async loadModels() {
        let url = null;

        url = `${config.api}/ticket?filter=${this.state.filter}`;

        if (this.state.sort) {
            url += `&sort=${this.state.sort}`;
        }

        if (this.state.type) {
            url += `&type=${this.state.type}`;
        }
        let res = await Axios.get(url);

        if (!this.isUnmounted) {
            this.setState({
                models: res.data.models,
                isLoading: false,
            });
        }
    }

    setOrder(sort: string) {
        this.setState(
            {
                type:
                    this.state.sort != sort
                        ? "asc"
                        : this.state.type == "asc"
                            ? "desc"
                            : "asc",
                sort,
                isLoading: true,
            },
            () => {
                this.loadModels();
            }
        );
    }

    handleModal() {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            () => {
                this.loadModels();
            }
        );
    }

    changeFilter(filter: string) {
        this.setState(
            {
                filter,
                isLoading: true,
                models: [],
            },
            () => {
                this.loadModels();
            }
        );
    }

    async delete(id: number) {
        let res = await Axios.get(`${config.api}/ticket/delete?id=${id}`);

        if (res.data.status == 'success'){
            this.loadModels();
        }
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-holders quastions">
                <TicketModal
                    isOpen={this.state.isOpen}
                    handleModal={this.handleModal}
                />

                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin">
                        Назад
                    </NavLink>
                    <span className="crm-holders__title">Вопросы</span>

                    <div
                        className="tabs-header mt-4"
                        style={{ justifyContent: "flex-start" }}
                    >
                        <a
                            role="button"
                            onClick={() => {
                                this.changeFilter("all");
                            }}
                        >
                            <div
                                className={
                                    "tabs-header__item px-3 pb-2 " +
                                    (this.state.filter == "all"
                                        ? "border-line"
                                        : "")
                                }
                            >
                                Все
                            </div>
                        </a>
                        <a
                            role="button"
                            onClick={() => {
                                this.changeFilter("producer");
                            }}
                        >
                            <div
                                className={
                                    "tabs-header__item px-3 pb-2 " +
                                    (this.state.filter == "producer"
                                        ? "border-line"
                                        : "")
                                }
                            >
                                От продюсеров
                            </div>
                        </a>
                        <a
                            role="button"
                            onClick={() => {
                                this.changeFilter("artist");
                            }}
                        >
                            <div
                                className={
                                    "tabs-header__item px-3 pb-2 " +
                                    (this.state.filter == "artist"
                                        ? "border-line"
                                        : "")
                                }
                            >
                                От партнеров
                            </div>
                        </a>
                    </div>

                    <div className="d-flex align-items-start fww">
                        <div className="crm-list mr-4">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder(
                                                        "date_update"
                                                    );
                                                }}
                                            >
                                                Последнее <br /> обновление{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("id");
                                                }}
                                            >
                                                Номер
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("user");
                                                }}
                                            >
                                                Пользователь{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("type");
                                                }}
                                            >
                                                Тип{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("department");
                                                }}
                                            >
                                                Категория{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("topic");
                                                }}
                                            >
                                                Тема{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("status");
                                                }}
                                            >
                                                Статус{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>Действие</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {!this.state.isLoading &&
                                        this.state.models.length == 0 && (
                                            <tr>
                                                <td colSpan={8}>
                                                    {t("Ничего не найдено")}
                                                </td>
                                            </tr>
                                        )}
                                    {this.state.isLoading && (
                                        <tr>
                                            <td colSpan={8}>
                                                {t("Загрузка данных")}
                                            </td>
                                        </tr>
                                    )}
                                    {this.state.models.map(
                                        (model: ITicketHead, i: number) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{model.date_update}</td>
                                                    <td>#{model.id}</td>
                                                    <td>
                                                        {model.user?.full_name}
                                                    </td>
                                                    <td>{model.user?.role}</td>
                                                    <td>{model.department}</td>
                                                    <td>{model.topic}</td>
                                                    <td
                                                        className={
                                                            model.statusName ==
                                                                "Открыт"
                                                                ? "text-success"
                                                                : model.statusName ==
                                                                    "Закрыт"
                                                                    ? "text-danger"
                                                                    : "text-warning"
                                                        }
                                                    >
                                                        {model.statusName}
                                                    </td>
                                                    <td>
                                                        <NavLink
                                                            to={
                                                                "/admin/question/" +
                                                                model.id
                                                            }
                                                            style={{
                                                                width: "70px",
                                                                display:
                                                                    "block",
                                                                padding:
                                                                    "5px 5px",
                                                                background:
                                                                    "#ef225d",
                                                                margin:
                                                                    "0 auto",
                                                                color: "#fff",
                                                            }}
                                                        >
                                                            Посмотреть
                                                        </NavLink>
                                                        <a role="button" className="d-inline-block mt-2" onClick={() => {
                                                            if (confirm("Удалить?")) {
                                                                this.delete(model.id);
                                                            }
                                                        }}>
                                                            Удалить
                                                        </a>
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="crm-holders__headline">
                            <a
                                className="crm-button"
                                role="button"
                                onClick={() => this.handleModal()}
                            >
                                Написать
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
    };
})(withTranslation()(Quastions));
